<template>
  <div class="note-page">
    <div class="note-page__inner">
      <note
        v-if="isEdit"
        @save="onNoteSave"
        @back="onNoteBack"
        @delete="onNoteDelete"
        :title="noteForUpdate.title"
        :completed="noteForUpdate.completed"
        :todos="noteForUpdate.todos"
        class="note-page__note"
      />
      <note
        v-else
        @back="onNoteBack"
        @save="onNoteSave"
        no-delete-btn
      />
    </div>

    <modal
      v-model="backModal"
      @confirm="goHome"
      title="You lose a lot"
      text="Unsaved changes will be lost."
    />
    <modal
      v-model="deleteModal"
      @confirm="onDeleteModalConfirm"
      title="Why?"
      text="Really delete note?"
    />
  </div>
</template>

<script>
import Note from '@/components/Note'
import clone from 'clone-deep'
import Modal from '@/components/Modal'

export default {
  name: 'Form',

  components: {
    Modal,
    Note
  },

  data: () => ({
    backModal: false,
    deleteModal: false
  }),

  computed: {
    isEdit() {
      return !!this.$route.params.id
    },

    noteForUpdate() {
      return clone(this.$store.getters.note(this.$route.params.id))
    }
  },

  methods: {
    onNoteSave(noteData) {
      if (this.isEdit) {
        this.updateNote(noteData)
      } else {
        const id = this.createNote(noteData)
        this.$router.push({ name: 'note', params: { id } })
      }
      this.$store.dispatch('saveNotes')
    },

    onNoteBack(newData) {
      if (newData) {
        this.backModal = true
      } else {
        this.goHome()
      }
    },

    createNote(noteData) {
      const newNote = {
        id: new Date().valueOf(),
        ...noteData
      }
      this.$store.commit('createNote', newNote)

      return newNote.id
    },

    updateNote(data) {
      this.$store.commit('updateNote', {
        id: this.$route.params.id,
        data
      })
    },

    goHome() {
      this.$router.push({ name: 'home' })
    },

    onNoteDelete() {
      this.deleteModal = true
    },

    onDeleteModalConfirm() {
      this.$router.push({ name: 'home' })
      this.$store.commit('deleteNote', this.$route.params.id)
      this.$store.dispatch('saveNotes')
    }
  }
}
</script>

<style lang="stylus" scoped>
.note-page

  &__inner
    max-width 600px
    margin auto

  &__note
    width 100%
</style>
